import { map } from 'lodash';
import {
    CLICK_SEND_MESSAGE_POST_FIRST_MESSAGE_POP_UP,
    CLICK_TOGGLE_MESSAGE_POST_FIRST_MESSAGE_POP_UP, DISMISS_OFFER_MORE_GIGS,
    POST_FIRST_MESSAGE_POP_UP_IS_SHOWN
} from '../../constants/biEvents';

export const getSendMessagesClickEvent = ({ baseMessageText, gigs, message }) => ({
    type: CLICK_SEND_MESSAGE_POST_FIRST_MESSAGE_POP_UP,
    params: {
        selectedGigIds: map(gigs, 'gig_id'),
        isOriginalMessage: baseMessageText === message
    }
});

export const getOfferMoreGigsShowEvent = ({ sentMessageData, sellerName, baseMessageText, gigs, message }) => ({
    type: POST_FIRST_MESSAGE_POP_UP_IS_SHOWN,
    params: {
        gigIds: map(gigs, 'gig_id'),
        baseMessage: {
            text: baseMessageText,
            id: sentMessageData.id
        },
        messageContainsSellerName: message.includes(sellerName)
    }
});

export const getToggleMessageEvent = ({ isShown }) => ({
    type: CLICK_TOGGLE_MESSAGE_POST_FIRST_MESSAGE_POP_UP,
    params: {
        isShown
    }
});

export const getDismissOfferMoreGigsEvent = () => ({
    type: DISMISS_OFFER_MORE_GIGS
});
